var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560059 14.6311L6.5 8.69112V10.8136L1.61756 15.6886C1.36256 15.6211 1.13006 15.4861 0.942559 15.3061C0.762559 15.1186 0.627559 14.8861 0.560059 14.6311Z",
    fill: "#C2C7D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.91002L0.5 8.90997V11.0325L6.5 5.03252V2.91002Z",
    fill: "#C2C7D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.25C1.175 2.25 0.5 2.925 0.5 3.75V5.25L3.5 2.25H2Z",
    fill: "#C2C7D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21753 15.75L6.5 15.75V14.4676L5.21753 15.75Z",
    fill: "#C2C7D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.75H8V17.25H6.5V0.75Z",
    fill: "#C2C7D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.25V3.75L12.5 3.75V2.25H14V3.75L15.5 3.75V5.25H14V12.75H15.5V14.25H14V15.75H12.5V14.25H9.5V12.75H12.5V5.25L9.5 5.25Z",
    fill: "#C2C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaIcon);
export default __webpack_public_path__ + "static/media/vaIcon.4f4d549209ef9a0063c30c81d572bc72.svg";
export { ForwardRef as ReactComponent };